import React from 'react';
import CheckBox from 'grommet/components/CheckBox';
import Box from 'grommet/components/Box';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import LineChartIcon from 'grommet/components/icons/base/LineChart';
import Section from 'grommet/components/Section';
import Tiles from 'grommet/components/Tiles';
import Tile from 'grommet/components/Tile';
import Anchor from 'grommet/components/Anchor';
import NumberInput from 'grommet/components/NumberInput';
import Label from 'grommet/components/Label';

class LRmse extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            learningrate: props.currentElement === "Logistic Gradient Descent CPU" || props.currentElement === "Logistic Gradient Descent" ? 1 : props.currentElement === "Multi Linear Regression" ? 0.0000002 : 0.0003, 
            iterations: 100, 
            r2: true, 
            scatter: true, 
            equation: true,
            methodology: null,
            error: true
             }
        this._onSelect = this._onSelect.bind(this);
    }
    _onClick(output) {
        this.props.onSubmit()
        this.props.onSubmit(output)
    }
    _onSelect(event) {
        this.setState({methodology: event})
    }
    _onChange(field, event) {
        const {r2, scatter, equation} = this.state
        switch(field) {
            case "learningrate":
                this.setState({ learningrate: event.target.value})
                break;
            case "iterations":
                this.setState({ iterations: event.target.value })
                break;
            case "r2":
                this.setState({ r2: !r2 })
                break;
            case "scatter":
                this.setState({ scatter: !scatter })
                break;
            case "equation":
                this.setState({ equation: !equation })
                break;
            case "error":
                this.setState({ error: event.target.value })
                break;
        }
    }
    render() {
        //let { topvalue, bottomvalue,rotate,stack,barcolor,columnwidth,title, legends, exprt } = this.state
        const {learningrate, iterations, scatter, equation, error} = this.state
        const output = {learningrate, iterations, scatter, equation, error}
        let content = (
                <div>
                <Box direction='row'
                        justify='center'
                        align='center'
                        wrap={true}
                        reverse={false}
                        margin='none'>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <CheckBox 
                                name='error'
                                id='error'
                                label='Error (SSE)'
                                toggle={true}
                                disabled={false}
                                reverse={true}
                                defaultChecked={true}
                                onChange={this._onChange.bind(this, 'error')}/>
                        </Box>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <CheckBox 
                                name='equation'
                                id='equation'
                                label='Equation'
                                toggle={true}
                                disabled={false}
                                reverse={true}
                                defaultChecked={true}
                                onChange={this._onChange.bind(this, 'equation')}/>
                        </Box>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <Label>
                            {"Learning Rate"}
                            </Label>
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                                <NumberInput defaultValue={learningrate} step={0.001} onChange={this._onChange.bind(this, 'learningrate')} />
                            </Box>
                        </Box>
                        <Box direction='row'    
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'> 
                            <Label>
                                {"Iterations"}
                            </Label>
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'> 
                                <NumberInput defaultValue={iterations} step={1} onChange={this._onChange.bind(this, 'iterations')} />
                            </Box>
                        </Box>
                </Box>
                <Button label='Submit'
            type='submit'
            primary={true}
            onClick={this._onClick.bind(this, output)} />
                </div>
            )
        return (
            <div>
                <Box>	  
                <h2><strong>Chose Options</strong></h2>
                </Box>
                <div style={{paddingTop: "10px"}}>
                {content}
                </div>
            </div>  
        );
    }
}

export default LRmse;




// WEBPACK FOOTER //
// ./src/samples/options/lrgd.js